/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions
     */
    AppStoreUrl: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions
     */
    AppStoreId: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions
     */
    AppLinkUrl: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions
     */
    BundleId: string;
}

/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions {
    if (!('AppStoreUrl' in value) || value['AppStoreUrl'] === undefined) return false;
    if (!('AppStoreId' in value) || value['AppStoreId'] === undefined) return false;
    if (!('AppLinkUrl' in value) || value['AppLinkUrl'] === undefined) return false;
    if (!('BundleId' in value) || value['BundleId'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'AppStoreUrl': json['AppStoreUrl'],
        'AppStoreId': json['AppStoreId'],
        'AppLinkUrl': json['AppLinkUrl'],
        'BundleId': json['BundleId'],
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsIosOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'AppStoreUrl': value['AppStoreUrl'],
        'AppStoreId': value['AppStoreId'],
        'AppLinkUrl': value['AppLinkUrl'],
        'BundleId': value['BundleId'],
    };
}

